module.exports = __webpack_public_path__ + "img/auth-bg.83ae5189.png";